




























import { IJobPosting } from '@app/componentlib/common/types/JobSearchTypes'
import { SavedAdvertsModule } from '@app/componentlib/src/store/modules/JobMatch/savedAdverts'

import JobResultList from '@app/componentlib/src/views/components/job-components/JobResultList.vue'
import JobDetailsView from '@app/componentlib/src/views/components/job-components/JobDetailsView.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { IResultPage } from '@app/componentlib/common/types/JobMatchTypes'

@Component<JobViewContainer>({
  props: {
    isSearching: Boolean,
    jobPostings: Array,
    activeIndex: Number,
    selectedJobPosting: Object,
    useSavedAdvert: Boolean,
    content: Object,
    jobmatch: Boolean,
    jobApplicationAccess: Boolean
  },
  components: {
    JobResultList,
    JobDetailsView,
  }
})

export default class JobViewContainer extends Vue {
  /**
   * Props variables
   */
  isSearching: boolean | undefined
  jobPostings: IJobPosting[] | undefined
  selectedJobPosting: IJobPosting | undefined
  useSavedAdvert: boolean | undefined
  jobmatch: boolean = false
  content: IResultPage | undefined
  jobApplicationAccess: boolean | undefined

  /**
   * Component state variables
   */

  /**
   * Lifecycle
   */

  /**
   * Getters
   */

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  get disableSearchForMore (): boolean {
    return SavedAdvertsModule.disableSearchForMore
  }


  /**
   * Methods
   */
  setSelectedJobPosting (jobPosting: IJobPosting | undefined) {
    this.$emit('setSelectedJobPosting', jobPosting)
  }

  setActiveIndex (index: number) {
    this.$emit('setActiveIndex', index)
  }

  toggleSavedAdvert (posting: IJobPosting) {
    if (posting.IsSavedAdvert === true) {
      //Remove posting as saved advert
      SavedAdvertsModule.deleteSavedAdvert(posting.JobId)
    } else {
      //Add posting as saved advert
      SavedAdvertsModule.createSavedAdvert(posting.JobId)
    }
  }

  async searchForMore () {
    //This emit is only used when showing results after search, not for showing savedAdverts
    if (this.disableSearchForMore === false) {
      this.$emit('searchForMore')
    }
  }
}
